VjsAdmin.Platforms = (function () {
    const $table = $('#platforms-table');

    const init = function () {
        initTable();
    };

    const initTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#platforms-table',
            idField: 'platform_id',
            sortName: 'platform_id',
            url: Slim.Router.pathFor('platforms.list.json'),
            columns: [
                {
                    title: 'ID',
                    field: 'platform_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    if (VjsAdmin.hasPermission('platforms.view')) {
                        const platformUrl = Slim.Router.pathFor('platforms.view', { platform_id: row.platform_id });
                        row.name = `<a href="${platformUrl}" class="btn btn-hollow-green">${row.name}</a>`;
                    }
                });
                return formattedResult;
            },
        });
    };

    return {
        init,
    };
}());
